import * as React from "react";
const NewsSocial1 = (props) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_594_873)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4031 15.5332C17.138 16.2836 16.0842 16.9044 15.2438 17.086C14.6685 17.2081 13.9183 17.3047 11.3905 16.2572C8.5514 15.081 4.609 10.8911 4.609 8.10283C4.609 6.6834 5.4274 5.03057 6.8585 5.03057C7.5471 5.03057 7.6989 5.04399 7.9255 5.58755C8.1906 6.22795 8.8374 7.80574 8.9144 7.96748C9.2323 8.63098 8.59099 9.01939 8.12569 9.59707C7.97719 9.77091 7.8089 9.95893 7.997 10.2824C8.184 10.5993 8.8308 11.6535 9.7812 12.4996C11.0088 13.5933 12.0043 13.9425 12.3607 14.0911C12.6258 14.2011 12.9426 14.1755 13.1362 13.9686C13.3815 13.7034 13.6862 13.2635 13.9964 12.8299C14.2153 12.5196 14.4936 12.4809 14.7851 12.5909C14.982 12.6591 17.4845 13.8213 17.5901 14.0073C17.6682 14.1426 17.6682 14.7828 17.4031 15.5332ZM11.0022 0H10.9967C4.93239 0 0 4.93389 0 11C0 13.4053 0.775508 15.6369 2.09441 17.4469L0.723805 21.5343L4.95111 20.1835C6.69021 21.3344 8.7659 22 11.0022 22C17.0665 22 22 17.0661 22 11C22 4.93389 17.0665 0 11.0022 0Z"
        fill={props.color}
      />
    </g>
    <defs>
      <clipPath id="clip0_594_873">
        <rect width={22} height={22} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NewsSocial1;
